import { Fragment } from "react";
import ReactMarkdown from "react-markdown";

const FormatedText = ({ value = "", singleLine = false, noFormat = false }) => {
  if (value) {
    return (
      <ReactMarkdown
        allowedElements={
          noFormat ? [] : singleLine ? ["strong", "em"] : ["strong", "p", "em"]
        }
        unwrapDisallowed={noFormat || singleLine}
        components={{
          p: (props) => {
            if (singleLine) {
              return <span>{props.children}</span>;
            }
            return <p>{props.children}</p>;
          },
        }}
        skipHtml
      >
        {value}
      </ReactMarkdown>
    );
  }
  return <Fragment />;
};

export default FormatedText;
